import { Component, EventEmitter, Output } from '@angular/core';
import {Common} from '../../shared/common';
import {UserData} from '../../models/UserData';

@Component({
  selector: 'add-user-popup',
  templateUrl: './add-user-popup.component.html',
  styleUrls: ['./add-user-popup.component.less', '../../shared/common.less']
})
export class AddUserPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() addUserEvent = new EventEmitter<UserData>();
  isFormValid: boolean = false;
  
  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  validateForm() {
    const lastName = (document.getElementById('lastName') as HTMLInputElement)?.value?.trim() || '';
    const firstName = (document.getElementById('firstName') as HTMLInputElement)?.value?.trim() || '';
    const email = (document.getElementById('email') as HTMLInputElement)?.value?.trim() || '';
    const profile = (document.getElementById('profile') as HTMLSelectElement)?.value || '';

    this.isFormValid = lastName !== '' && firstName !== '' && email !== '' && profile !== '';
  }

  onAddUser() {
    const lastName = (document.getElementById('lastName') as HTMLInputElement)?.value || '';
    const firstName = (document.getElementById('firstName') as HTMLInputElement)?.value || '';
    const email = (document.getElementById('email') as HTMLInputElement)?.value || '';
    const sendInvitation = (document.getElementById('sendInvitation') as HTMLInputElement)?.checked || false;
    const profile = parseInt((document.getElementById('profile') as HTMLSelectElement)?.value || '-1', 10);

    const userData = {
      lastName,
      firstName,
      email,
      sendInvitation,
      profile
    };

    this.addUserEvent.emit(userData);
  }

  ngOnInit() {}

  /**
   * Valide le format d'une adresse email
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

}
